import React, { useState } from "react";

import styles from "../../../../styles/add-product.module.scss";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Steps } from "../../../components/Steps";
import { Input } from "../../../components/Input";
import { Textarea } from "../../../components/Textarea";
import { Icon } from "../../../components/core/Icon";
import { AssetsAPI } from "../../../../providers/AssetsAPI"
import SetSizesStep from "./SetSizesStep";
import SetAvailabilityStep from "../SetAvailabilityStep";
import SetStagesStep from "./SetStagesStep";
import { ProductDrink } from "./FormSteps/ProductDrink";
import { ProductPizza } from "./FormSteps/ProductPizza";
import { ProductSteps } from "./FormSteps/ProductSteps";


export default class AddProduct extends React.Component {
	state = {
		step: 0,
		steps: null,
		currentStep: 0,
		disabled: false
	}

	getHeaderTitle(category) {
		if (category.name) {
			return `Adicionar produto - ${category.name}`;
		}
	}


	render() {
		const { open, category, catalog, onClose, onSave, categories } = this.props;
		const { step } = this.state;

		return (
			<Drawer visible={open} closeInFade={false} title={this.getHeaderTitle(category)} onClose={onClose}>
				{category.mode == 'drink' && (<ProductDrink category={category} onSave={(productData) => onSave && onSave(productData)} />)}
				{category.mode == 'step' && (<ProductSteps category={category} catalog={catalog} onSave={(productData) => onSave && onSave(productData)} />)}
				{category.mode == 'pizza' && (<ProductPizza category={category} onSave={(productData) => onSave && onSave(productData)} />)}
			</Drawer>
		)
	}

}


// const AddProduct = ({ category, open, close, setOpen, onSave, categories }) => {
// 	const [step, setStep] = useState(1);
// 	const [currentStep, setCurrentStep] = useState(1);
// 	const [addStep, setAddStep] = useState(false);
// 	const [product, setProduct] = useState({
// 		parent: category.id,
// 		type: category.mode,
// 		sizes: [...category.sizes],
// 		has_steps: false,
// 		items: [],
// 		image: null,
// 		name: null,
// 		desc: null,
// 		availability: null,
// 	});





// 	const nextStep = (_step) => {
// 		if (_step) {
// 			setStep(_step);
// 			return false;
// 		}

// 		if (step === 1) {
// 			if (category.sizes.length > 1) {
// 				setCurrentStep(2);
// 				setStep(2);
// 				return false;
// 			}
// 		}

// 		setStep(step + 1);
// 		setCurrentStep(currentStep + 1);
// 	};

// 	const prevStep = (_step) => {
// 		if (_step) {
// 			setStep(_step);
// 			return false;
// 		}

// 		setStep(step - 1);
// 		setCurrentStep(currentStep - 1);
// 	};

// 	const onChangeProductSize = (value, index) => {
// 		const sizes = [...product.sizes];
// 		sizes[index].base_price = value;
// 		setProduct({ ...product, sizes });
// 	};

// 	const onChangeProductPromo = (sizes, index) => {
// 		setProduct({ ...product, sizes });
// 	};

// 	const onChangeProductStageSteps = (value) => {
// 		console.log(value, product);
// 		setProduct({ ...product, items: value, has_steps: true });
// 		console.log(value, product);
// 	};

// 	const onChangeProductHasSteps = (value) => {
// 		setProduct({ ...product, has_steps: value });
// 	};

// 	return (
// 		<Drawer
// 			visible={open}
// 			onClose={(status) => setOpen(false)}
// 			title={getHeaderTitle()}
// 		>
// 			<div className={styles.scrollContainer}>
// 				<Steps steps={4} currentStep={currentStep}>
// 					{step === 1 && (
//
// 					)}

// 					{
// 						step === 2 &&
// 						<SetSizesStep
// 							categoryType={category.mode}
// 							category={category}
// 							product={product}
// 							onChange={(value, index) => onChangeProductSize(value, index)}
// 							onChangePromo={(sizes, index) => onChangeProductPromo(sizes, index)}
// 						/>
// 					}

// 					{step === 3 && (
// 						<SetStagesStep
// 							categories={categories}
// 							category={category}
// 							product={product}
// 							setAddStep={(status) => setAddStep(status)}
// 							onChange={(value) => onChangeProductStageSteps(value)}
// 							onChangeHasSteps={(value) => onChangeProductHasSteps(value)}
// 						/>
// 					)}

// 					{step === 4 && <SetAvailabilityStep item={product} />}
// 				</Steps>
// 			</div>

// 			{!addStep && (
// 				<div
// 					className={`${styles.footer} ${step > 1 ? "justify-between" : "justify-end"
// 						}`}
// 				>
// 					{step > 1 && (
// 						<Button design="default-icon" onClick={prevStep}>
// 							<Icon name="long-arrow-left" size="xl" />
// 						</Button>
// 					)}
// 					{step < 4 && (
// 						<Button design="primary-icon" onClick={nextStep}>
// 							<Icon name="long-arrow-right" size="xl" />
// 						</Button>
// 					)}
// 					{step === 4 && (
// 						<Button
// 							design="primary-icon"
// 							onClick={() => onSave && onSave(product)}
// 						>
// 							<Icon name="check" size="xl" />
// 						</Button>
// 					)}
// 				</div>
// 			)}
// 		</Drawer>
// 	);
// };

// export default AddProduct;
